import { BOOKING_TYPE_CARDS } from '../constants';
import * as styled from '../styles/booking-types';
import { SectionHeading } from './section-heading';

export const BookingTypes = () => (
  <styled.Wrap>
    <SectionHeading
      title="Get booked. Get picked."
      subtitle="Your following proves people watch you. Your page proves you're worth paying."
      align="center"
    />
    <styled.Grid>
      {BOOKING_TYPE_CARDS.map((card) => (
        <styled.Card key={card.title} $variant={card.variant}>
          <styled.Title $variant={card.variant}>{card.title}</styled.Title>
          <styled.Description $variant={card.variant}>{card.description}</styled.Description>
          <styled.BulletList>
            {card.bullets.map((bullet) => (
              <styled.Bullet key={bullet} $variant={card.variant}>
                <styled.BulletMark $variant={card.variant}>✓</styled.BulletMark>
                {bullet}
              </styled.Bullet>
            ))}
          </styled.BulletList>
        </styled.Card>
      ))}
    </styled.Grid>
  </styled.Wrap>
);
